/**
 * Created by anatoly on 27.12.2024.
 */

const GeneratorHintView = function () {
    this.hintFinger = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("generate", this.show.bind(this));
};

GeneratorHintView.prototype.show = function (move) {
    this.hide();

    this.hintFinger = FingerView.hintTap(move.cell, {
        delay: move.delay / 1000,
        repeatDelay: move.interval / 1000
    });
};

GeneratorHintView.prototype.hide = function () {
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;
};
